// extracted by mini-css-extract-plugin
export default {"column__icon":"TAYDZ"};